import React from "react";
import { Link } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";

import CenterSpinner from "components/CenterSpinner";

import { useFeaturedPresentations } from "hooks/query";
import { useSection } from "hooks/section";
import SpacedList from "components/SpacedList";

import "./Featured.css";
import PresentationItem from "components/PresentationItem";

const filterFeaturedPresentations = () => {

}

export default function FeaturedPresentations() {
    let { sectionUrl } = useSection();
    const { data, isSuccess, isLoading } = useFeaturedPresentations();
    return (    
        <div className="Featured">
           {sectionUrl == "traineeprogram" ? 
           (<h2 className="mb-3 margin">Arbetsgivare i fokus</h2>):
           (<h2 className="mb-3 mt-5 margin">Utbildare i fokus</h2>)}
                <Link className="linkColor marginFeatured" to={"/presentationer/" + sectionUrl}> Se alla</Link>
            {isLoading && <CenterSpinner />}

            <div className="FeaturedPresentations">           
                {isSuccess &&
                    data.$values.map((educator) => {
                        return <PresentationItem key={educator.slug} educator={educator} sectionUrl={sectionUrl} />;
                    })}
            </div>
        </div>
    );
}

